import React from 'react';

const GetUser = () => {
	return (
		<div>
			<h2 id="tasks_user">Get a User</h2>
			<p>We are going to request the profile on user 1000, our sample user. In addition to asking for the basic user, we are using the “include” property to ask for the user’s profile images and channels.</p>

			<h4>Request:</h4>
			<pre className="language-bash"><code className="language-bash">curl "http://sample.api.voicestorm.com/v1/user/1000?include=images&amp;include=channels"</code></pre>

			<h4>Response:</h4>
			<pre className="language-javascript"><code className="language-javascript">{`{
	id: 1000,
	userName: "sample@user.com",
	displayName: "Sample User",
	fullName: "Sample User",
	firstName: "Sample",
	lastName: "User",
	organizationName: "SA",
	displayNameFormat: "Full",
	status: "Active",
	lastActivityDate: "2013-07-26T22:41:34.2370000Z",
	title: "My Title",
	location: "Somewhere, USA",
	aboutMe: "This is what I have to say about myself",
	followerCount: 1013,
	isPublic: false,
	pointBalance: 5949,
	unredeemedPoints: 5949,
	redeemedPoints: 0,
	createdDate: "2012-03-12T18:39:50.9770000Z",
	modifiedDate: "2013-08-10T01:21:49.8870000Z",
	profileUrls: ["http://www.myprofilepage.com"],
	statistics: {
		shareCount: 123,
		reactionCount: 3,
		impressionCount: 162,
		clickCount: 16739
	},
	tags: {
		tags: {}
	},
	userChannels: [
	{
		userChannelId: 1000,
		userId: 1000,
		provider: "Blogger",
		name: "Hello world!",
		displayName: "Hello world!",
		providerUserId: "0",
		status: "Active",
		url: "http://sample.blogspot.com/",
		friends: 0,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 485,
		sourceDisplayName: "Hello world!",
		reach: 0,
		statistics: {
			shareCount: 9,
			reactionCount: 0,
			impressionCount: 0,
			clickCount: 48
		}
	},
	{
		userChannelId: 171,
		userId: 1000,
		externalId: "00000000-0000-0000-0000-000000000000",
		provider: "Facebook",
		name: "sample.user",
		displayName: "Sample User",
		providerUserId: "100000000000000",
		status: "Active",
		url: "http://www.facebook.com/sample.user",
		friends: 11,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 423,
		sourceDisplayName: "Sample User",
		reach: 11,
		statistics: {
			shareCount: 24,
			reactionCount: 3,
			impressionCount: 83,
			clickCount: 15117
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/7928f82c-cf80-4d60-8651-daddfbe57128",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/7928f82c-cf80-4d60-8651-daddfbe57128_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			},
		}
	},
	{
		userChannelId: 1242,
		userId: 1000,
		externalId: "00000000-0000-0000-0000-000000000000",
		provider: "FacebookPage",
		displayName: "MyCommunity",
		providerUserId: "200000000000000",
		status: "Active",
		url: "https://www.facebook.com/pages/MyCommunity/200000000000000",
		friends: 0,
		followers: 1,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 158,
		sourceDisplayName: "MyCommunity",
		reach: 1,
		statistics: {
			shareCount: 19,
			reactionCount: 0,
			impressionCount: 4,
			clickCount: 295
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/f8ca10af-0333-49f3-b629-19ced98d938e",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/f8ca10af-0333-49f3-b629-19ced98d938e_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 815,
		userId: 1000,
		provider: "GooglePlus",
		name: "Sample User",
		displayName: "Sample User",
		providerUserId: "111111111111111111111",
		status: "Active",
		url: "https://plus.google.com/111111111111111111111",
		friends: 0,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 0,
		sourceDisplayName: "Sample User",
		reach: 0,
		statistics: {
			shareCount: 0,
			reactionCount: 0,
			impressionCount: 0,
			clickCount: 0
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/685edf2b-620c-4524-8e95-4cda360991bb",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/685edf2b-620c-4524-8e95-4cda360991bb_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 8606,
		userId: 1000,
		provider: "LinkedIn",
		name: "Sample User",
		displayName: "Sample User",
		providerUserId: "0000000000",
		status: "Active",
		url: "http://www.linkedin.com/pub/sample-user/00/000/000",
		friends: 10,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 22,
		sourceDisplayName: "Sample User",
		reach: 10,
		statistics: {
			shareCount: 2,
			reactionCount: 0,
			impressionCount: 20,
			clickCount: 1
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/b40e25ad-689c-46a2-af11-4ddd7a266e6c",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/b40e25ad-689c-46a2-af11-4ddd7a266e6c_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 864,
		userId: 1000,
		provider: "Tumblr",
		name: "Sample User",
		displayName: "Sample User",
		providerUserId: "sample.tumblr.com",
		status: "Active",
		url: "http://sample.tumblr.com/",
		friends: 0,
		followers: 0,
		following: 6,
		posts: 75,
		views: 0,
		pointBalance: 155,
		sourceDisplayName: "Sample User",
		reach: 0,
		statistics: {
			shareCount: 6,
			reactionCount: 0,
			impressionCount: 0,
			clickCount: 32
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/35b80540-5b56-4def-8dfd-cd2b53cb2711",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/35b80540-5b56-4def-8dfd-cd2b53cb2711_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 850,
		userId: 1000,
		externalId: "00000000-0000-0000-0000-000000000000",
		provider: "Twitter",
		name: "sampleuser",
		displayName: "sampleuser",
		providerUserId: "000000000",
		status: "Active",
		url: "http://twitter.com/sampleuser",
		friends: 0,
		followers: 10,
		following: 17,
		posts: 710,
		views: 0,
		pointBalance: 578,
		sourceDisplayName: "sampleuser",
		reach: 10,
		statistics: {
			shareCount: 27,
			reactionCount: 0,
			impressionCount: 106,
			clickCount: 47
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/635f8f0b-269c-4583-b988-bb6024af9b3c",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/635f8f0b-269c-4583-b988-bb6024af9b3c_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 878,
		userId: 1000,
		provider: "TypePad",
		name: "Sample's blog",
		displayName: "Sample's blog",
		providerUserId: "sampleuser",
		status: "Active",
		url: "http://sampleuser.typepad.com/blog/",
		friends: 0,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 90,
		sourceDisplayName: "Sample's blog",
		reach: 0,
		statistics: {
			shareCount: 6,
			reactionCount: 0,
			impressionCount: 0,
			clickCount: 27
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/5e3873bf-4509-4129-b6b3-603fea1f76be",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/5e3873bf-4509-4129-b6b3-603fea1f76be_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	},
	{
		userChannelId: 885,
		userId: 1000,
		provider: "WordPress",
		name: "sampleuser",
		displayName: "sampleuser | Just another WordPress.com site",
		providerUserId: "sampleuser",
		status: "Active",
		url: "http://sampleuser.wordpress.com",
		friends: 0,
		followers: 0,
		following: 0,
		posts: 0,
		views: 0,
		pointBalance: 315,
		sourceDisplayName: "sampleuser | Just another WordPress.com site",
		reach: 0,
		statistics: {
			shareCount: 5,
			reactionCount: 0,
			impressionCount: 0,
			clickCount: 4830
		},
		profilePictureImages: {
			Original: {
				size: "Original",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/76eb2f3d-48ca-49b1-ace5-0fee116ff1db",
				mimeType: "image/png"
			},
			Square160: {
				size: "Square160",
				cdnUrl: "https://ssl.rackcdn.com/101/UserChannelIcon/76eb2f3d-48ca-49b1-ace5-0fee116ff1db_S160",
				width: 160,
				height: 160,
				mimeType: "image/png"
			}
		}
	}],
	securityGroups: ["Member", "PostAuthor"],
	profilePictureImages: {
		Original: {
			size: "Original",
			cdnUrl: "https://ssl.rackcdn.com/101/UserPicture/e6d7bfc6-daa0-459f-a3a0-fad3d02d576e",
			mimeType: "image/jpeg"
		},
		Square160: {
			size: "Square160",
			cdnUrl: "https://ssl.rackcdn.com/101/UserPicture/e6d7bfc6-daa0-459f-a3a0-fad3d02d576e_S160",
			width: 160,
			height: 160,
			mimeType: "image/jpeg"
		}
	}
}
			`}
			</code></pre>
		</div>
	);
};

export default GetUser;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/GetUser.js